const FormHeader = ({ children, title, icon }) => {
    return (
        <div className='form-header'>
            <div className="section-one">
                <span className="icon">{icon}</span>
                <span className="title">{title}</span>
            </div>
            <div className="section-two">
                {children}
            </div>
        </div>
    );
};

export default FormHeader;
